// =============================================================================
// Reminder / daily-digest settings shared by the calendar sheet and Settings.
//
// Shared calendars keep one setting for every member on the shared_calendars
// row; the personal calendar keeps its own in
// settings.notificationPrefs.calendars.personal. The server side
// (edge-functions/scheduled-notifications) reads both once a minute.
// =============================================================================

export const DEFAULT_TZ = 'Europe/Vienna';

// Lead times offered for "remind me before an event", in minutes. 0 = off.
export const REMINDER_OPTIONS = [0, 5, 10, 15, 30, 60, 120, 1440];

export const reminderLabel = (minutes, t) => {
  const n = Number(minutes) || 0;
  if (n <= 0) return t('notify.none');
  if (n >= 1440) return t('notify.oneDay');
  if (n >= 60 && n % 60 === 0) return t('notify.hours', { n: n / 60 });
  return t('notify.minutes', { n });
};

export const deviceTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TZ;
  } catch (_) {
    return DEFAULT_TZ;
  }
};

// The server words messages in the user's language and schedules the
// personal digest in their zone; both ride along in the prefs JSON.
export const stampLocale = (prefs, lang) => {
  const tz = deviceTimeZone();
  const p = prefs || {};
  if (p.lang === lang && p.tz === tz) return null;
  return { ...p, lang, tz };
};

export const isTimeStr = (s) => /^([01]\d|2[0-3]):[0-5]\d$/.test(String(s || ''));
